import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';


const PrivacyPolicy = () => {

    return (
        <>
            <SEO title="Privacy Policy" />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Privacy Policy"
                page="Privacy Policy"
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                <div className="section-title">
                                    <h5 className="title">This Privacy policy was published on December 31st, 2024.</h5>
                                </div>
                                <h4>GDPR Compliance</h4>
<p>At NewwayIT, we are committed to ensuring the security and protection of personal data we handle. We comply with GDPR regulations to safeguard your privacy and rights. Our policies and practices align with the highest standards of data protection.</p>

<h4>About NewwayIT</h4>
<p>NewwayIT specializes in delivering innovative software solutions designed to enhance business efficiency and digital transformation. If you have any inquiries regarding this policy or your data, feel free to contact us at:</p>
<p><strong>Email:</strong> <a href="mailto:privacy@newwayit.com">privacy@newwayit.com</a></p>

<h4>When We Collect Personal Data About You</h4>
<p>We collect personal data in several scenarios, such as:</p>
<ul>
    <li>When you visit our website or use our services.</li>
    <li>When you communicate with us via email or other channels.</li>
    <li>During subscription to newsletters or marketing campaigns.</li>
    <li>When you engage with us through customer support or feedback forms.</li>
</ul>

<h4>Why We Collect and Use Personal Data</h4>
<p>We collect and process personal data to:</p>
<ul>
    <li>Provide and improve our software and services.</li>
    <li>Personalize user experiences and optimize performance.</li>
    <li>Communicate effectively, including customer support and marketing updates.</li>
    <li>Comply with legal and regulatory obligations.</li>
</ul>

<h4>Type of Personal Data Collected</h4>
<p>We may collect the following types of personal data:</p>
<ul>
    <li>Contact details such as name, email, and phone number.</li>
    <li>Business information including job title and company name.</li>
    <li>Technical data such as IP address, browser type, and usage patterns.</li>
</ul>

<h4>Information We Collect Automatically</h4>
<p>Certain information is collected automatically when you interact with our platforms:</p>
<ul>
    <li>Log data including access times and visited pages.</li>
    <li>Device information such as operating system and browser type.</li>
    <li>Referral data from external links or advertisements.</li>
</ul>

<h4>The Use of Cookies and Web Beacons</h4>
<p>NewwayIT employs cookies and web beacons to enhance user experience and improve our website functionality:</p>
<ul>
    <li>Cookies store small data files on your device to personalize your visit.</li>
    <li>Web beacons (or tracking pixels) allow us to understand user behavior and optimize content delivery.</li>
</ul>
<p>This data does not personally identify you unless combined with other information you voluntarily provide.</p>

<h4>How Long We Keep Your Data</h4>
<p>We retain personal data for as long as necessary to:</p>
<ul>
    <li>Fulfill the purposes for which it was collected.</li>
    <li>Address inquiries, support requests, and legal obligations.</li>
    <li>Resolve disputes and safeguard our operations.</li>
</ul>
<p>Data retention is reviewed periodically to ensure it aligns with these objectives.</p>

<h4>Your Rights to Your Personal Data</h4>
<p>As a user, you have rights under GDPR, including:</p>
<ul>
    <li>Accessing, rectifying, or erasing your data.</li>
    <li>Objecting to or restricting processing activities.</li>
    <li>Requesting data portability.</li>
    <li>Withdrawing consent where applicable.</li>
</ul>
<p>For any concerns or requests, contact us at <a href="mailto:privacy@newwayit.com">privacy@newwayit.com</a>.</p>

<h4>Changes to This Privacy Policy</h4>
<p>We may update this Privacy Policy to reflect changes in legal, regulatory, or operational practices. Any significant changes will be communicated through our website or directly to you, where applicable.</p>

<p><strong>Effective Date:</strong> [31st December 2024]</p>
<p>For further questions, please contact us at <a href="mailto:privacy@newwayit.com">privacy@newwayit.com</a>.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default PrivacyPolicy;